import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['questions', 'setup', 'continue', 'submit', 'hint']

  connect () {
    this.recompute()
  }

  recompute () {
    if (this.hasContinueTarget) {
      const show = this.questionsDone
      const ready = show && this.choicesValid
      this.continueTarget.classList.toggle('hidden', !show)
      this.gate(this.continueTarget, ready)
      if (this.hasHintTarget) this.hintTarget.classList.toggle('hidden', !(show && !ready))
    }
    if (this.hasSubmitTarget) this.gate(this.submitTarget, this.destinationDone)
  }

  gate (button, ok) {
    button.disabled = !ok
    button.classList.toggle('opacity-40', !ok)
    button.classList.toggle('cursor-not-allowed', !ok)
  }

  showSetup (event) {
    event.preventDefault()
    if (!(this.questionsDone && this.choicesValid)) return
    this.questionsTarget.classList.add('hidden')
    this.setupTarget.classList.remove('hidden')
    window.scrollTo({ top: 0 })
  }

  showQuestions (event) {
    event.preventDefault()
    this.setupTarget.classList.add('hidden')
    this.questionsTarget.classList.remove('hidden')
    window.scrollTo({ top: 0 })
  }

  async create (event) {
    event.preventDefault()
    if (this.submitting || event.currentTarget.disabled) return

    const form = document.getElementById(event.currentTarget.getAttribute('form'))
    if (!form) return

    this.submitting = true
    try {
      await this.pendingSaves()
    } finally {
      this.submitting = false
    }

    form.requestSubmit()
  }

  pendingSaves () {
    const controllers = Array.from(this.element.querySelectorAll('[data-controller~="auto-save"]'))
      .map((el) => this.application.getControllerForElementAndIdentifier(el, 'auto-save'))
      .filter((controller) => controller)

    return Promise.all(controllers.map((controller) => controller.settled()))
  }

  get nameDone () {
    return this.value('form[title]').trim().length > 0
  }

  get destinationDone () {
    if (!this.value('form[project_id]')) return false
    const idField = {
      todolist: 'form[todolist_id]',
      card_column: 'form[column_id]',
      message_board: 'form[message_board_id]',
      schedule: 'form[schedule_id]'
    }[this.value('form[target]')]
    return !!(idField && this.checked(idField))
  }

  get questionsDone () {
    return this.activeRows.some((row) => {
      const label = row.querySelector('[name$="[label]"]')
      return label && label.value.trim().length > 0
    })
  }

  get choicesValid () {
    return this.activeRows.every((row) => {
      const type = row.querySelector('input[name$="[kind]"]')?.value
      if (type !== 'single_choice' && type !== 'multiple_choice') return true
      const options = Array.from(row.querySelectorAll('input[name$="[options][]"]'))
      return options.some((o) => o.value.trim().length > 0)
    })
  }

  get activeRows () {
    return Array.from(this.element.querySelectorAll('[data-form-fields-target~="row"]'))
      .filter((row) => !row.classList.contains('hidden'))
  }

  value (name) {
    const el = this.element.querySelector(`[name="${name}"]`)
    return el ? el.value : ''
  }

  checked (name) {
    return this.element.querySelector(`[name="${name}"]:checked`)?.value || ''
  }
}
